import { parseTilesetConfigEntry, type RawTilesetEntry, type TilesetConfigEntry } from "../tilesetConfigEntry";
import { bossEntries } from "./boss";
import { effectEntries } from "./effects";
import { enemyCorpseEntries } from "./enemyCorpses";
import { enemyEntries } from "./enemies";
import { environmentEntries } from "./environment";
import { levelDesignEntries } from "./levelDesign";
import { projectileEntries } from "./projectiles";
import { specialEntries } from "./special";
import { structureEntries } from "./structures";
import { terrainEntries } from "./terrain";
import { vegetationEntries } from "./vegetation";

const rawEntries: RawTilesetEntry[] = [
	...enemyEntries,
	...enemyCorpseEntries,
	...bossEntries,
	...projectileEntries,
	...effectEntries,
	...environmentEntries,
	...terrainEntries,
	...structureEntries,
	...vegetationEntries,
	...levelDesignEntries,
	...specialEntries,
];

export const allTilesetEntries: TilesetConfigEntry[] = rawEntries.map(parseTilesetConfigEntry);
